// extracted by mini-css-extract-plugin
var _1 = "AvatarWithStatus-modulestatusIndicator__WVbLb";
export { _1 as "statusIndicator" }
